import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";
import { Logo } from "@/components/Logo";
import { NAV } from "@/lib/constants";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export function Navbar() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const nav = useNavigate();

  return (
    <header className="fixed top-0 inset-x-0 z-50 sp-glass" data-testid="public-navbar">
      <div className="sp-container flex items-center justify-between h-16">
        <Link to="/" data-testid="nav-logo"><Logo dark /></Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase()}`}
                  className="text-sm text-white/75 hover:text-white transition-colors">
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <Button data-testid="nav-dashboard-btn" onClick={() => nav("/app")}
                    className="bg-sp-orange hover:bg-sp-orangedark text-white rounded-full px-5">
              Dashboard <ArrowRight className="ml-1 h-4 w-4" />
            </Button>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login"
                    className="text-sm text-white/80 hover:text-white transition-colors">Login</Link>
              <Link to="/business" data-testid="nav-business"
                    className="text-sm text-white/80 hover:text-white transition-colors">For Business</Link>
              <Button data-testid="nav-start-project" onClick={() => nav("/register")}
                      className="bg-sp-orange hover:bg-sp-orangedark text-white rounded-full px-5">
                Start a Project
              </Button>
            </>
          )}
        </div>

        <button className="lg:hidden text-white" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden sp-glass border-t border-white/10 px-5 py-4 space-y-3" data-testid="nav-mobile-menu">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} onClick={() => setOpen(false)}
                  className="block text-white/80 py-1">{n.label}</Link>
          ))}
          <div className="pt-3 flex flex-col gap-2">
            {user ? (
              <Button onClick={() => nav("/app")} className="bg-sp-orange text-white rounded-full">Dashboard</Button>
            ) : (
              <>
                <Link to="/login" className="text-white/80 py-1">Login</Link>
                <Button onClick={() => nav("/register")} className="bg-sp-orange text-white rounded-full">Start a Project</Button>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
